import { view } from '@yola/ws-sdk';
import getDataFromMediaNode from 'src/js/modules/extensions/common/helpers/get-data-from-media-node';
import getLinkConfig from 'src/js/modules/extensions/common/helpers/get-link-config';
import mediaTypes from 'src/js/modules/extensions/registry/ws-gallery/constants/media-types';

const getMediaType = (element) => {
  const iframeElement = element?.querySelector('ws-iframe');

  if (iframeElement) return mediaTypes.IFRAME;

  return mediaTypes.IMAGE;
};

const getDataFromNode = (mediaElement) => {
  const elementId = view.accessors.getLiveElementId(mediaElement);
  const linkElement = mediaElement.querySelector('a');
  const mediaType = getMediaType(mediaElement);
  const { mediaContainerData, imageData, iframeData } = getDataFromMediaNode(mediaElement, true);
  const linkConfig = getLinkConfig(linkElement, mediaElement);
  const shouldUseTitleForAlt = imageData?.alt === imageData?.title;

  return {
    mediaType,
    ...mediaContainerData,
    ...(mediaType === mediaTypes.IMAGE && {
      ...imageData,
    }),
    ...(mediaType === mediaTypes.IFRAME && {
      src: iframeData?.src,
      iframeData,
    }),
    elementId,
    linkConfig,
    shouldUseTitleForAlt,
  };
};

export default getDataFromNode;
